"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  app_name: "Fysiotest Europa AB",
  common: {
    placeholders: {
      email: "E-mail",
      password: "Password",
      personal_number: "YYYYMMDDXXXX",
      personal_number_full: "Personal number",
      gender: "Sex",
      company: "Company",
      office: "Office",
      department: "Department",
      individual_client: "Individual client",
      mark_all: "Mark all",
      no_data: "No data"
    },
    messages: {
      unknown_error: "Something went wrong... try again",
      email: "info@fysiotest.se",
      fysiotest_email: "E-mail:",
      large_image_error: "Image is too large.",
      large_image_size_error: "Image is too large. Recommended size is {size}Mb",
      large_file_size_error: "File is too large. Recommended size is {size}Mb",
      isIE: "The web page you are trying to reach requires one of the browsers below to work optimally.",
      image_updated: "Image is updated successfully"
    },
    words: {
      second: "{count} second | {count} seconds",
      and: "and",
      or: "or",
      no_records: "No results",
      add: "Add",
      edit: "Edit",
      yes: "Yes",
      no: "No"
    },
    buttons: {
      log_out: "Log out",
      previous_page: "Back",
      ok: "Ok",
      cancel: "Cancel",
      change_test_result_date: "Change date of test result",
      change_appointment_date: "Edit appointment"
    },
    menus: {
      my_profile: "My profile",
      companies: "Companies",
      projects: "Projects",
      admins: "Admins",
      test_managers: "Test Managers",
      tests: "Tests",
      composed_tests: "Composed Tests",
      customers: "Customers"
    },
    calendar: {
      monday_short: "Mo",
      tuesday_short: "Tu",
      wednesday_short: "We",
      thursday_short: "Th",
      friday_short: "Fr",
      saturday_short: "Sa",
      sunday_short: "Su",
      january_long: "January",
      february_long: "February",
      march_long: "March",
      april_long: "April",
      may_long: "May",
      june_long: "June",
      july_long: "July",
      august_long: "August",
      september_long: "September",
      october_long: "October",
      november_long: "November",
      december_long: "December"
    }
  },
  login: {
    headers: {
      login: "Log in",
      two_factor_authentication: "Two-factor authentication",
      verification_code_info: "A verification code has been sent\nto your email.\nEnter the code to continue.",
      contact_us: "Contact us"
    },
    buttons: {
      login_bank_id: "With BankID",
      login_email: "With e-mail",
      start_login: "Log in",
      forgot_password: "Forgot your password?",
      next_step: "Next",
      try_again: "Try again",
      start_bank_id_app: "Start your BankID app",
      start_bank_id_same_device: "Start bank id on this device",
      start_bank_id_another_device: "Bank id on another device"
    },
    placeholders: {
      two_factor_placeholder: "Choose where you want to get code for authorization",
      two_factor_email: "Send code on email",
      two_factor_sms: "Send code on mobile phone"
    },
    messages: {
      short_personal_number: "Enter your social security number with 12 digits",
      open_bank_id: "Start the BankID app and press the Scan QR button. Then scan the QR code above",
      bank_id_failed: "Login via BankID failed. Please try again",
      failed_to_scan: "Failed to scan the QR code. Start the BankID app and scan the QR code"
    }
  },
  sign_up: {
    headers: {
      register: "Register",
      register_bank_id: "Register with {app_name}",
      register_email: "Register with {app_name}",
      two_factor_authentication: "Two-factor authentication",
      verification_code_is_sent: "A verification code has been sent\nto your email.\nEnter the code to continue."
    },
    buttons: {
      register_bank_id: "With BankID",
      register_email: "With e-mail",
      register: "Register",
      login: "Log in"
    },
    placeholders: {
      firstname: "First name",
      lastname: "Last name",
      phone: "Mobile phone",
      password: "Create a password",
      confirm_password: "Confirm password",
      date_of_birth: "Date of birth"
    },
    messages: {
      open_bank_id_app: "Open the BankID app and approve",
      personal_number_is_registered: "The personal number is already registered. Log in instead",
      email_is_registered: "E-mail is already registered. Log in instead",
      weak_password: "Weak password!"
    },
    validation: {
      firstname: {
        empty: "First name is required"
      },
      lastname: {
        empty: "Last name is required"
      },
      date_of_birth: {
        empty: "Date of birth is required",
        invalid_date: "Date of birth from personal number is invalid"
      },
      email: {
        empty: "E-mail is required",
        incorrect_format: "E-mail must be in correct format - local-part@domain"
      },
      personal_number: {
        incorrect_length: "Enter your social security number with 12 digits"
      },
      company: {
        empty: "Company is required"
      },
      office: {
        empty: "Office is required"
      },
      department: {
        empty: "Department is required"
      },
      phone: {
        empty: "Phone is required",
        invalid: "Phone is invalid"
      },
      gender: {
        empty: "Gender is required"
      },
      password: {
        not_match: "Passwords do not match",
        short: "Password length must be more or equal to 8 characters",
        no_uppercase: "Password must contain an uppercase character",
        no_lowercase: "Password must contain a lowercase character",
        no_digit: "Password must contain a digit",
        no_non_alphabetical: "Password must contain a non-alphabetical character"
      }
    }
  },
  reset_password: {
    headers: {
      enter_email: "Please enter your e-mail address",
      reset_password: "Reset your password using secret code from your e-mail"
    },
    buttons: {
      send_new_secret_code: "Didn't get an email? Click here to send new secret code",
      send_secret_code: "Send",
      set_new_password: "Set new password"
    },
    placeholders: {
      secret_code: "Secret code",
      create_password: "Create a password",
      confirm_password: "Confirm password"
    },
    messages: {
      resend_secret_code_counter: "Didn't get an email? You can send new secret code in",
      password_is_set: "New password is set!",
      weak_password: "Weak password!"
    },
    validation: {
      secret_code: {
        empty: "Secret code is required"
      },
      password: {
        not_match: "Passwords do not match",
        short: "Password length must be more or equal to 8 characters",
        no_uppercase: "Password must contain an uppercase character",
        no_lowercase: "Password must contain a lowercase character",
        no_digit: "Password must contain a digit",
        no_non_alphabetical: "Password must contain a non-alphabetical character"
      }
    }
  },
  terms: {
    headers: {
      page_header: "{app_name} - Terms and conditions",
      terms_accept: "Terms of use app.fysiotest.se.",
      show_terms: "Terms and conditions",
      terms_details_1: "1. Who is responsible for your personal data?",
      terms_details_2: "2. What personal data does Fysiotest process?",
      terms_details_3: "3. For what purposes do we process your personal data?",
      terms_details_4: "4. How long do we store your personal data?",
      terms_details_5: "5. How do you access your data in ‘My Portal’?",
      terms_details_6: "6. How do we protect your personal data?",
      terms_details_7: "7. How are ‘Cookies’ used?",
      terms_details_8: "Contact information"
    },
    messages: {
      welcome: "Welcome {name}!",
      welcome_description: "Here in our portal you can book time for health examination, fill in health declaration and see results on your tests. Read through and approve the terms of use to proceed.",
      accept_checkbox: " I accept Fysiotests terms and conditions",
      terms_details_0: "\n        <p>We protect your personal privacy and therefore want to be clear with these terms of use and privacy policy about what information we collect about you and why, when you use our services or visit our website. To become a registered user of app.fysiotest.se, you need to read and accept this policy.</p>\n      ",
      terms_details_1: "\n        <p>1.1 Fysiotest Europa AB (\u201CFysiotest\u201D or \u201Cthe Company\u201D), corporate registration number 556796-0330, Box 2096 141 02 Huddinge, is the data controller for the processing of personal data on this website. The Company\u2019s processing of customer data complies with the General Data Protection Regulation (GDPR).</p>\n        <p>1.2 With \u201CUsers\u201D we refer to individuals and \u201Ccustomers\u201D refers to companies that use the Company\u2019s services for blood tests, health checks, health coaching and other services that then receive health records regarding the current results via app.fysiotest.se.</p>\n        <p>1.3 The processing of personal data when using the Company's services takes place after the user has been informed about and given their consent to the processing. The processing of personal data is also supported by the General Data Protection Regulation (GDPR).</p>              \n        <p>1.4 The Company also complies with other relevant legislation such as the \u201COffentlighets- och sekretesslagen\u201D (2009:400) and \u201CPatientdatalagen\u201D (2008:355) in the parts that concern the customer's personal data. This means that the rules from these laws may precede the GDPR in certain parts that concern the customer's personal data.</p>\n      ",
      terms_details_2: "\n        <p>2.1 The Company collects personal data such as first name, last name, email address, telephone number, gender and social security number from customers in connection with the use of the Company's services. The Company's services are related to the collection of health data in connection with blood tests, health checks and other services. We only collect the data that is necessary to deliver the service.</p>\n      ",
      terms_details_3: "\n                <p>3.1 Personal data is used to provide the Company's services to users and customers. Personal data is also used to make health data available to users. Health data is collected for the purpose of optimizing nutrition, exercise and recovery. Health data collected by the Company is not used for medical purposes. Personal data is used when sending information prior to current health checks and for customers at our physical clinics where these also include billing.</p>\n                <p>3.2 Health data may be analyzed in an anonymized form and compiled in general reports for use by both users and customers to summarize results at group level. The data in the report is compiled in such a way that it can never be linked to an individual and/or individual personal data to ensure that the anonymity and integrity of the users are maintained.</p>\n                <p>3.3 The Company's customers and registered users consent to marketing via various channels such as mail, telephone, email, text messages and other digital channels. Marketing via email and text messages is regulated in accordance with the Marketing Act.</p>\n                <p>3.4 In order for Fysiotest to be able to provide our services, we need to cooperate with other actors, such as health coaches, labs and system suppliers. We may therefore transfer your personal data and seek the assistance of other actors to process your personal data when necessary to (1) fulfill the agreement with you, (2) comply with law, regulation or decision. The following types of recipients may be relevant:</p>\n                <p>a) Sampling partners and labs - Fysiotest cooperates with various sampling partners and laboratories to take and analyze some of the samples included in ordered analyses.</p>\n                <p>b) Contracted personnel - Fysiotest has collaborations with selected actors who perform sampling and health coaching.</p>\n                <p>c) Authorities - Personal data is only disclosed to authorities when required by law or authority decision.</p>\n                <p>d) Notification services - Fysiotest uses services to communicate automatically to you, e.g. with confirmations or reminders. These companies only have access to your contact information and have undertaken not to share your personal data beyond what is necessary to perform the service.</p>\n                <p>e) Developers and consultants \u2013 Fysiotest uses developers and consultants from other companies to build our IT infrastructure and further develop the service. Such developers may need to access personal data about you when this is needed for development or troubleshooting.</p>\n                <p>f) Your employer \u2013 With the legal basis of Fysiotest, your employer and your own legitimate interest to form an invoicing basis and report for possible benefit taxation, Fysiotest will only disclose your name to your employer if your employer has ordered and/or paid for the health test you have taken.</p>\n                <p>3.5 Sensitive data about you, including your health data, is processed in accordance with the law. Such data will therefore only be accessible to such personnel who are required to have access to it by law. The data will not be disclosed or transferred to any recipient other than when permitted by law.</p>\n                <p>3.6 Third country transfer<br>Fysiotest processes as much of its data as possible within the EU/EEA. If data is transferred to be processed by a supplier or subcontractor outside the EU/EEA, the recipient has always entered into contractual terms with Fysiotest that ensure that the recipient maintains a level of protection comparable to the EU/EEA.</p>\n            ",
      terms_details_4: "\n                <p>\n                    4.1 Personal data is stored for the duration of an ongoing contractual relationship and for a period thereafter, or in accordance with the consent given. The customer can withdraw their consent at any time.\n                </p>\n                <p>\n                    4.2 For patient records, the Company as a healthcare provider saves these in accordance with applicable legislation, usually for at least ten (10) years from the time the last data was entered into the document.\n                </p>\n                <p>\n                    4.3 The Company retains the users' personal data for accounting purposes in accordance with the requirements of the Accounting Act, usually for seven years.\n                </p>\n                <p>\n                    4.4 The data in \"My Portal\" is classified as a patient record and the Company as a healthcare provider saves these in accordance with applicable legislation, usually for at least ten (10) years from the time the last data was entered into the document. The user has the right to have their data deleted upon request. Other personal data and data linked to the user account such as company affiliation may be filtered or depersonalized when the data is no longer needed for the purposes for which it was collected. Personal data for user accounts with ongoing activity and/or balance are exempt from filtering.\n                </p>\n                <p>\n                    4.5 During the retention period, the use of personal data is limited with regard to the specific purposes for which it was collected. The deletion is irreversible and once it has been carried out, no person can be associated with the user account anymore.\n                </p>\n            ",
      terms_details_5: "\n                <p>\n                    5.1 Users of Fysiotest\u2019s services have the opportunity to read and access their data themselves via app.fysiotest.se. Under \u201CMy Portal\u201D where he or she can follow their test results and follow their values over time. Here the user can find information about how the result should be interpreted from a health-promoting perspective.\n                </p>\n                <p>\n                    5.2 Registry extract. All Fysiotest users have the right to withdraw consent in writing free of charge, request a registry extract or correction/deletion of possibly incorrect data. If you want to request a registry extract, withdraw consent or correct/delete data, please contact us.\n                </p>\n            ",
      terms_details_6: "\n                <p>\n                    6.1 The Company, as the data controller, takes appropriate technical and organizational measures to ensure the protection of the personal data processed, in accordance with the requirements of the GDPR and other applicable laws and regulations.\n                </p>\n            ",
      terms_details_7: "\n                <p>\n                    7.1 The Company\u2019s website uses cookies. Cookies are small text files that are stored on the visitor\u2019s device and that enable the website to recognize the visitor and collect information about their activities on the website.\n                </p>\n                <p>\n                    7.2  There are two main types of cookies:\n                    <ul class=\"ml-min\">\n                        <li>\n                            Permanent cookie: This type of cookie remains on the visitor\u2019s device for a certain period of time, even after the browser has been closed.\n                        </li>\n                        <li>\n                            Session cookie: This type of cookie is temporarily stored in the device\u2019s memory for the time the visitor is on the website and disappears when the browser is closed.\n                        </li>\n                    </ul>\n                </p>\n                <p>\n                    7.3 The Company uses cookies for the following reasons:\n                    <ul class=\"ml-min\">\n                        <li>\n                            To ensure that the services on the website function properly.\n                        </li>\n                        <li>\n                            To collect anonymized visitor statistics and analyze user behavior to improve the website's performance and user experience.\n                        </li>\n                        <li>\n                            To customize and display advertisements based on the visitor's interests and behavior.\n                        </li>\n                    </ul>\n                </p>\n                <p>\n                    7.4 No personal information, such as email address or name, is stored in cookies about the visitor.\n                </p>\n                <p>7.5 If the visitor does not want cookies to be used, they can turn off cookies in their browser's security settings. Please note that some functions of the website may not function properly if cookies are disabled.</p>\n                <p>7.6 The visitor can also configure their browser so that they receive a warning each time the website attempts to place a cookie on their device. In addition, previously stored cookies can be deleted through the browser's settings. For more information about this, see the browser's help pages.</p>\n                <p>7.7 For further information about cookies, the visitor can contact the Swedish Post and Telecom Agency, which is the supervisory authority responsible for the area. Visit the PTS website at http://www.pts.se/</p>\n              ",
      terms_details_8: "\n        <p>If you wish to exercise your rights under GDPR, you can send a letter to Fysiotest at the following address:</p>\n        <p>Fysiotest Europa AB<br>Box 2096<br>141 02 Huddinge<br>Sweden</p>\n        <p>Or send an email to Fysiotest at <a href=\"mailto:info@fysiotest.se\">info@fysiotest.se</a></p>\n        <p><i>These terms of use were established in August 2017 and were last updated in January 2026 by Fysiotest Europa AB.</i></p>\n      "
    },
    buttons: {
      accept_terms: "I accept"
    }
  },
  dashboard: {
    headers: {
      my_portal: "My health and performance",
      welcome: "Welcome {name}",
      health_goals: "Health goals",
      new_health_goal: "New health goal",
      no_tests: "You will be able to see your development when you have more tests registered.",
      outdated_occasion: "Test date has passed",
      deleted_occasion: "Test occasion was deleted",
      book_time: "Book an appointment",
      no_booking_time: "No available appointments",
      edit_health_goal: "Edit goal",
      you_have_booked: "You have booked: {date}",
      you_have_booked_time: "You have booked",
      booked_time: "{date} for {type}",
      you_have_booked_location: "Location",
      cancel_appointment: "Cancel the appointment?",
      click_here: "Click here",
      messages: "Messages"
    },
    messages: {
      welcome_information: "On this page you can book time for lifestyle coaching, fill in health questionnaire and see reports on your previous results.",
      no_health_goals: "No goals",
      occasion_date: "Date",
      occasion_files: "Information",
      occasion_project: "Project",
      occasion_deleted_project: "Deleted project",
      occasion_contact: "Contact",
      select_type: "Select the service",
      select_location: "Select the location",
      select_date_and_time: "Select the date and time",
      test_is_completed: "Test is completed",
      test_is_deleted: "Test is deleted",
      healthdeclaration_is_submitted: "{name} is submitted",
      waiting_for_test: "Waiting for {name}",
      time_is_booked: "Booked appointment",
      waiting_for_booking: "Waiting for your booking",
      status: "Status",
      test: "Test",
      sms_sent: "SMS sent"
    },
    buttons: {
      add_health_goal: "Add health goal",
      create_health_goal: "Add goal",
      cancel_booking: "Cancel the appointment ({date})",
      open_book_time_menu: "Book time",
      open_healthdeclaration: "Fill in {name}",
      open_covid_certificate: "E-Hälsomyndighet - {name}",
      book_time: "Book",
      save_health_goal: "Save",
      upload_goal_picture: "Upload a picture to describe your goal",
      change_goal_picture: "Change picture?",
      save: "Save",
      cancel: "Cancel",
      cancel_on_icon: "Cancel",
      test_results: "My test results",
      test_development: "My development"
    },
    placeholders: {
      your_goal: "Your goal",
      select_booking_date: "Select date",
      select_booking_type: "Select service",
      select_booking_location: "Select location",
      select_booking_time: "Select time",
      goal: "Goal"
    },
    deleteBookingConfirmation: "Are you sure you want to cancel your appointment?"
  },
  footer: {
    headers: {
      newsletter: "Get inspired by our newsletter"
    },
    placeholders: {
      email: "E-mail address"
    },
    buttons: {
      subscribe: "Subscribe"
    }
  },
  user_profile: {
    titles: {
      delete_info: "Send request to delete account",
      datepicker: "Editing the date of birth is restricted because it is already fetched from the personal number"
    },
    buttons: {
      save_profile_picture: "Save",
      cancel: "Cancel",
      change_profile: "Change profile",
      update_profile_information: "Update information",
      delete_request: "Delete my account",
      delete: "Delete"
    },
    placeholders: {
      change_picture: "Change picture",
      gender_male: "Male",
      gender_female: "Female"
    },
    messages: {
      health_goals_count: "Health goals",
      tests_count: "Tests"
    },
    validation: {
      email_personal_number: {
        empty: "Either email or personal number or both must be specified"
      }
    }
  },
  tests: {
    headers: {
      question_description: "Description"
    },
    buttons: {
      download_pdf: "Download PDF",
      submit: "Submit",
      create_covid_passport: "Create Covid passport"
    },
    messages: {
      user_answer: "Your answer",
      value: "Value",
      reference_value: "Reference value",
      show_less: "- Show less",
      show_more: "+ More information",
      inbody_vfa_result: "Your Visceral Fat Area is <span class=\"underline\">%{answer}</span>.",
      inbody_result: "Your result: {result}",
      inbody_over: "Over",
      inbody_under: "Under",
      inbody_normal: "Normal",
      inbody_result_over: "Your result {result} is over",
      inbody_result_under: "Your result {result} in under",
      inbody_result_normal: "Your result {result} is normal",
      inbody_normal_ranges: "Your normal ranges: {minRange} – {maxRange}",
      inbody_normal_ranges_percentages: "Normal ranges in percentages: {minRange} – {maxRange}",
      inbody_weight: "Weight (kg)",
      inbody_smm: "Skeletal Muscle Mass (kg)",
      inbody_bfm: "Body Fat Mass (kg)",
      inbody_pbf: "Percent Body Fat (%)",
      inbody_vfa: "Visceral Fat Area (%)",
      yes_answer: "Yes",
      no_answer: "No",
      starting_autosave: "Starting autosaving results...",
      successful_autosave: "Results were successfully autosaved",
      unsuccessful_autosave: "Error autosaving test results",
      autosave_applied: "Autosaved results were applied"
    }
  },
  round: {
    enter_valid_name: "Please enter a valid name"
  },
  occasion: {
    cards: {
      files: {
        action: "Upload"
      }
    },
    forms: {
      upload_file: {
        title: "New Files"
      },
      inbody: {
        title: "New InBody test",
        file_name_mismatch: 'The file name "{file}" does not include the full name for {fullName}'
      }
    }
  },
  test_types: {
    headers: {
      name: "Name",
      global: "Global",
      created: "Created",
      updated: "Updated",
      test_type: "Test type",
      test_category: "Category"
    },
    columns: {
      yes: "yes",
      no: "no"
    }
  },
  contact: {
    message_not_sent: "Message is not sent"
  },
  occasion_times: {
    time: "Time",
    booked: "Booked",
    name: "Name",
    type: "Type",
    location: "Location",
    bulk_delete: "To delete several times at the same time, click on the lines you wish to delete",
    add_time: "Add a time",
    add_bulk_times: "Add multiple times",
    open_booking: "Open bookings",
    lock_bookings: "Lock bookings",
    remove_selected: "Remove selected",
    select_type: "Select service",
    select_location: "Select location"
  },
  report: {
    created: "Report file created"
  },
  confirmation_modal: {
    title: "Are you sure?",
    text: "You will not be able to return to this!"
  },
  occasion_files: {
    removed: "File is removed"
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/translations/en.js
// module id = ARZ6
// module chunks = 0 1